export default __webpack_public_path__ + "static/media/72.5e377fc5.jpg";